import { FaWhatsapp, FaPhone } from "react-icons/fa";
import "./FloatingContacts.css";

export default function FloatingContacts() {
  return (
    <div className="floating-contacts">
      <a
        href="https://wa.me/79180466720"
        target="_blank"
        rel="noopener noreferrer"
        className="contact-btn whatsapp"
      >
        <FaWhatsapp />
      </a>
      <a href="tel:+79180466720" className="contact-btn phone">
        <FaPhone />
      </a>
    </div>
  );
}
